// Selects all the text within an HTML input element
export const selectAllText = (input: HTMLInputElement) => {
  if (input.value) {
    input.setSelectionRange(0, input.value?.length);
  }
};

export const getBorderColor = (hasError: boolean, isEditMode: boolean, canEdit: boolean) => {
  if (!canEdit) {
    return 'transparent';
  }
  if (hasError) {
    return 'color-mix(in srgb, var(--destructive) 40%, transparent)';
  }
  if (isEditMode) {
    return 'var(--border)';
  }
  return 'transparent';
};

export const getHoverBorderColor = (hasError: boolean, isEditMode: boolean, canEdit: boolean) => {
  if (hasError) {
    return 'color-mix(in srgb, var(--destructive) 40%, transparent)';
  }
  if (isEditMode) {
    return 'var(--border)';
  }
  if (canEdit) {
    return 'var(--border)';
  }
  return 'transparent';
};
